import { useQuery } from '@tanstack/react-query';
import { BarChart3 } from 'lucide-react';
import { Link } from 'react-router';
import { Card, Empty, Loading, PageHeader, Table, Td, Th } from '../components/ui';
import { get } from '../lib/api';
import { date, mt } from '../lib/format';

export function AccountsPage() {
  const q = useQuery({ queryKey: ['aging'], queryFn: () => get('/accounts/aging') });
  if (q.isLoading || !q.data) return <Loading />;
  const rows = q.data.rows as Record<string, string>[];
  const sum = (k: string) => rows.reduce((s, r) => s + Number(r[k] ?? 0), 0);
  const cols: [string, string][] = [['current', 'A vencer'], ['d30', '1–30 dias'], ['d60', '31–60'], ['d90', '61–90'], ['d90plus', '> 90 dias'], ['total', 'Total']];
  return (
    <>
      <PageHeader title="Contas correntes" subtitle={`Antiguidade de saldos a ${date(q.data.today)}`} />
      <Card>
        {!rows.length ? <Empty icon={<BarChart3 className="size-6" />} title="Nenhum valor por receber">Todas as facturas estão liquidadas.</Empty> : (
          <Table>
            <thead><tr><Th>Cliente</Th>{cols.map(([, l]) => <Th key={l} className="text-right">{l}</Th>)}<Th /></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.customer_id} className="hover:bg-[var(--surface-2)]">
                  <Td><Link className="font-medium hover:underline" to={`/clientes/${r.customer_id}`}>{r.name}</Link><div className="text-xs text-muted">{r.nuit ?? ''} {r.phone ?? ''}</div></Td>
                  {cols.map(([k]) => <Td key={k} className={`num ${k === 'total' ? 'font-semibold' : ''} ${['d60', 'd90', 'd90plus'].includes(k) && Number(r[k]) > 0 ? 'text-red-700 dark:text-red-400' : ''}`}>{Number(r[k]) ? mt(r[k]) : '—'}</Td>)}
                  <Td className="text-right"><Link className="text-sm font-medium whitespace-nowrap text-brand-700 hover:underline" to={`/clientes/${r.customer_id}?tab=extracto`}>Extracto / aviso</Link></Td>
                </tr>
              ))}
              <tr className="font-semibold"><Td>Total</Td>{cols.map(([k]) => <Td key={k} className="num">{mt(sum(k))}</Td>)}<Td /></tr>
            </tbody>
          </Table>
        )}
      </Card>
    </>
  );
}
